import {getHexDistance} from "../../coords/getHexDistance";
import {isUnitFaction} from "../isUnitFaction";
import {FACTIONS} from "../../../constants/factions";
import {CITY_COMMON_BUILDING_TOKENS, SPECIAL_BUILDING_TOKENS} from "../../../constants/tokens";
import {GOBLINS_ABILITY_RADIUS, GOBLINS_MIN_UNIT_SIZE_FOR_ABILITY} from "../../../configs/factions/goblins";
import {hasAdjacentEnemyUnit} from "../../gameState/hasAdjacentEnemyUnit";
import {isBuildingDestroyed} from "../../gameState/shooting/buildingDamageUtils";
import {hasObstacleInPath} from "../../gameState/shooting/calculateAvailableShootingCells";

const CITY_BUILDING_PROPERTIES = [
  'centralQuarter',
  ...Object.values(CITY_COMMON_BUILDING_TOKENS),
  ...Object.values(SPECIAL_BUILDING_TOKENS),
];

/**
 * Гексы вражеских строений, доступные для повреждения Гоблинами: радиус
 * GOBLINS_ABILITY_RADIUS И прямая видимость (нет горы/непобеждённой крепости
 * на линии — та же hasObstacleInPath, что и у соблазнения Суккубов/стрельбы
 * катапульт, по прямому запросу пользователя). Аналог getEnemyCityBuildingHexKeys
 * (calculateAvailableShootingCells.js), но самостоятельная реализация —
 * гоблинское повреждение строений применяется немедленно, отдельным
 * reducer-кейсом, а не через pendingShootingActions (см. design.md
 * Decision 7), поэтому pendingShootingActions в isBuildingDestroyed/
 * hasObstacleInPath всегда []
 */
export const calculateAvailableBuildingDamageCells = (
  hexes, citiesCache, specialBuildings, buildingsDamage, units, selectedUnit, currentPlayer, fortressesUnderConstruction
) => {
  if (!selectedUnit
    || !isUnitFaction(selectedUnit, FACTIONS.GOBLINS)
    || selectedUnit.hasUsedAbilityThisWarPhase
    || selectedUnit.size < GOBLINS_MIN_UNIT_SIZE_FOR_ABILITY
    || !citiesCache
    || !currentPlayer
  ) {
    return [];
  }

  if (hasAdjacentEnemyUnit(selectedUnit.hexKey, selectedUnit.ownerId, units)) {
    return [];
  }

  const targetHexKeys = new Set();

  Object.entries(citiesCache).forEach(([playerColor, cities]) => {
    if (playerColor === currentPlayer.color) return;

    cities.forEach(city => {
      const hasIntactOrdinaryQuarters = city.quarter && city.quarter.some(qHexKey =>
        !isBuildingDestroyed(qHexKey, specialBuildings, buildingsDamage, [], hexes)
      );

      CITY_BUILDING_PROPERTIES.forEach(property => {
        if (property === 'centralQuarter' && hasIntactOrdinaryQuarters) {
          return;
        }

        const value = city[property];
        if (!value) return;

        const addHexKey = (hexKey) => {
          if (isBuildingDestroyed(hexKey, specialBuildings, buildingsDamage, [], hexes)) {
            return;
          }
          if (getHexDistance(selectedUnit.hexKey, hexKey) > GOBLINS_ABILITY_RADIUS) {
            return;
          }
          if (hasObstacleInPath(
            selectedUnit.hexKey, hexKey, hexes, specialBuildings, [], buildingsDamage, fortressesUnderConstruction
          )) {
            return;
          }
          targetHexKeys.add(hexKey);
        };

        if (Array.isArray(value)) {
          value.forEach(addHexKey);
        } else if (typeof value === 'string') {
          addHexKey(value);
        }
      });
    });
  });

  return [...targetHexKeys];
};
